import * as React from 'react';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../../../utils';
import AddPassengerForm from '../../../../../AddPassenger/components/AddPassengerForm/AddPassengerForm';
import SlideBottom from '../../../../../SlideBottom/components/SlideBottom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../theme';
const AddPassengerWrapper = props => {
    const [open, setOpen] = React.useState(props.isOpen || false);
    const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });
    const { t } = useTranslation('Checkout');
    const theme = useTheme('Checkout').GroupOrder;
    const onLabelClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setOpen(true);
    };
    const initialValues = props.passenger
        ? {
            lastName: props.passenger.passengerName,
            id: props.passenger.passengerId
        }
        : null;
    return open && !isMobile ? (React.createElement("div", { className: theme.editPassenger },
        React.createElement(AddPassengerForm, { onSubmit: (lastName, id) => {
                var _a;
                return props.onAddPassenger(lastName, id, (_a = props.passenger) === null || _a === void 0 ? void 0 : _a.id);
            }, onSuccess: () => setOpen(false), initialValues: initialValues, hideIcon: true, buttonText: t(props.passenger ? 'Done' : 'Add'), validationType: "ticketNumber" }))) : (React.createElement(React.Fragment, null,
        isMobile && (React.createElement(SlideBottom, { isOpen: open, onClose: () => setOpen(false) },
            React.createElement(AddPassengerForm, { onSubmit: (lastName, id) => {
                    var _a;
                    return props.onAddPassenger(lastName, id, (_a = props.passenger) === null || _a === void 0 ? void 0 : _a.id);
                }, onSuccess: () => setOpen(false), initialValues: initialValues, hideIcon: true, buttonText: t(props.passenger ? 'Done' : 'Add'), validationType: "ticketNumber" }))),
        React.createElement("div", { onClick: onLabelClick }, props.children)));
};
export default AddPassengerWrapper;
